import React from 'react';

/** Lazy ClientComputedMetadata (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedMetadata = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-metadata' */
            './ConnectedClientComputedMetadata'
        ),
);
